/*  ========================================================================
    # Scripts - Logo Map
    ========================================================================  */

import { animate, inView } from 'motion';

/**
 * Script to handle the accordion section functionality
 */

const LogoMap = {
  cfg: {
    containers: document.querySelectorAll('.s-logomap')
  },

  initializeMaps() {
    this.cfg.containers.forEach(container => {
      const brexbach = container.querySelector('.s-logomap__brexbach path#brexbach');

      if (window.prefersReducedMotion) {
        // Apply style instantly on page load
        brexbach.setAttribute('stroke-dasharray', '1px 0px');
      } else {
        // Animate Brexbach once when it enters the viewport
        inView(
          container,
          () => {
            animate(brexbach, { pathLength: [0, 1] }, { duration: 3, ease: 'easeInOut' });
          },
          { amount: 0.5 }
        );
      }

      const logo = container.querySelector('.s-logomap__z');
      if (window.prefersReducedMotion) {
        // Apply style instantly on page load
        logo.setAttribute('style', 'transform: translate(-50%, 300%) scale(0.27);');
        logo.setAttribute('fill', '#fe733d');
      } else {
        // Animate Z logo when it comes into view
        inView(
          container,
          () =>
            animate(
              logo,
              {
                scale: [1, 0.27],
                y: [0, '300%'],
                x: [0, '-50%'],
                fill: ['#2D2D2D', '#fe733d']
              },
              { duration: 3, ease: 'easeInOut' }
            ),
          { amount: 0.5 }
        );
      }
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.containers) {
      this.initializeMaps();
    }
  }
};

export default LogoMap;
